import i18n from '@hw-core/libs/i18n'

export const SHIFT_UPDATE_STATES = {
    updated: 'updated',
    created: 'created'
}

export const SHIFT_STATUSES = {
    open: 'open',
    pending: 'pending',
    expired: 'expired',
    draft: 'draft',
    booked: 'booked',
}

export const SHIFT_WORK_TYPE = {
    work: 'work'
}

export const SHIFT_BOOST_TYPES = {
    quick: { label: i18n.t('quick'), value: 'quick'},
    bonus:  { label: i18n.t('bonus'), value: 'bonus' },
}

export const SHIFT_BOOST_TYPE_OPTIONS = [
    { label: i18n.t('quick'), value: 'quick' },
    { label: i18n.t('bonus'), value: 'bonus' },
]

export const SHIFT_DEFAULT_VALUES = {
    roleType: localStorage.getItem('locale') === 'fi'
        ? 'lähihoitaja'
        : ''
}